import flatten from 'lodash/flatten';
import base from '@framework/url/baseUrl';
import urlJoin from '@framework/url/helpers/urlJoin';
import buildUrl from '@framework/url/helpers/buildUrl';
import domain from '@framework/config/domain';
import condorConfig from '@condor/config';
import shouldUseInternalNetwork from '@framework/router/Next/shouldUseInternalNetwork';
import isServer from '@framework/router/Next/isServer';

export default {
  getUrl(...uris: (string | string[])[]): string {
    if (!Array.isArray(uris)) {
      uris = [uris];
    }
    uris = flatten(uris).filter((uri) => !!uri);
    return buildUrl(domain.protocol, `${ condorConfig.hostname }`, condorConfig.routes.drs, ...uris);
  },

  getBaseUrl(...uris: string[]): string {
    return buildUrl(domain.protocol, `${ condorConfig.hostname }`, ...uris);
  },

  getPropagateUrl(): string {
    return `${ this.getBaseUrl('/proxy/condor/api/propagate') }`;
  },

  getPropagateCallbackUrl(url: string): string {
    return `${ this.getPropagateUrl() }?callbackUrl=${ encodeURIComponent(url) }`;
  },

  getApiUrl(...uris: string[]): string {
    return base.getApiUrl('condor', ...uris);
  },

  getUrlPathname(...uris: (string | string[])[]): string {
    return urlJoin(condorConfig.routes.drs, ...uris);
  },

  getRpcUrl(): string {
    if (shouldUseInternalNetwork()) {
      return this.getInternalRpcUrl();
    }

    if (!isServer()) {
      return this.getProxyApiRpcPath();
    }

    return base.getApiUrl('/condor/rpc');
  },

  getProxyApiRpcPath() {
    return `${ this.getProxyPath() }/rpc`;
  },

  getProxyPath() {
    return `${ window.location.protocol }//${ window.location.hostname }/proxy/condor`;
  },

  getInternalRpcUrl(): string {
    return `${ condorConfig.api.internal }/rpc`;
  },

  getOpenMarketFilesUrl(...uris: string[]): string {
    return base.getApiUrl('/open-market/files', ...uris);
  },
};
